import { ControlComponent } from "../../controls/control.component";
import { IonicFormInput } from "ionic-angular";
import { BaseInput } from "ionic-angular/util/base-input";
import * as tabbable from "tabbable";
import { ElementRef } from "@angular/core";

interface ICommon {
    getElementRef(): ElementRef;
}

export class ControlComponentAdaptor {

    constructor(protected controlComponent?: ControlComponent | IonicFormInput) {

    }

    focus(): void {

        if (!this.controlComponent) {
            return;
        }

        try {
            switch (true) {
                case this.controlComponent instanceof ControlComponent: {
                    (this.controlComponent as ControlComponent).focus();
                    break;
                }
                case this.controlComponent instanceof BaseInput: {
                    (this.controlComponent as IonicFormInput).initFocus();
                    break;
                }
                default: {
                    // noop
                }
            }
        } catch (e) {
            console.warn(e);
        }
    }

    getTabbableElements(): Array<HTMLElement> {

        if (!this.controlComponent) {
            return [];
        }

        try {
            return tabbable((this.controlComponent as ICommon).getElementRef().nativeElement);
        } catch (e) {
            console.warn(e);
            return [];
        }
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/field-wrapper/control-component-adaptor.ts